export default __webpack_public_path__ + "locales/fi/SendInviteDialog.json?hash=5d04ab83c8090ec0654837c4ea3a3723";